import { Component, OnInit, ChangeDetectionStrategy, ViewChild, EventEmitter, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { SystemService } from '../../../../services/system.service';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { combineLatest, Observable, Subject, Subscription, of } from 'rxjs';
import {  MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {  MatTableDataSource } from '@angular/material/table';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { CommonPopup } from '../../../common-popup/common-popup';

import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';
import { Iframe } from 'src/app/shared/iframe';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class LinksComponent implements OnInit, OnDestroy {

  siteId: string;
  systemId: string;
  fragment: string;
  user: User;
  product$;
  combObs$ = new Subject;
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: any; }[] = [];

  @ViewChild(MatSort,{static:false}) sort: MatSort;
  @ViewChild(MatPaginator,{static:false}) paginator: MatPaginator;

  // 'updatedOn', 'createdOn', 'createdBy', 'detail', 'status', 'action'
  // displayedColumns: string[] = ['name', 'maxLimit', 'threshold', 'quantity', 'fillStatus'];
  columnSettings: ColumnSetting[] = [
    {
      columnId: 'name',
      name: 'Link name',
      maxLengthOnMobile: 15
    },
    {
      columnId: 'link',
      name: 'Link',
      type:'url'
    },
  
  ]


  dataSource$: Observable<MatTableDataSource<any>>;
  projects$: Observable<any>;
  // siteId: string;
  projects: MatTableDataSource<any>;
  haveFilter = false;

  onEdit: EventEmitter<ActionButtonEvent>;
  onAdd: EventEmitter<ActionButtonEvent>;
  onDelete: EventEmitter<ActionButtonEvent>;
  onTransactionsSubscription: Subscription;
  onDeleteSubscription: Subscription;
  onEditSubscription: Subscription;
  onAddSubscription: Subscription;
  onMinusSubscription: Subscription;
  getLinks = new Observable
  getStockSub = new Subscription
  getStockArray = new Array()

  stockUpdateArray = new Array()
  topbarActionButton: { icon: string; tooltip: string; eventEmitter: any; }[] = [];

  constructor(private route: ActivatedRoute,
    public dialog: MatDialog,
    private sysService: SystemService,
    public auth: AuthService) {

    combineLatest(this.route.parent.params, this.route.params).subscribe(params => {

      this.siteId = params[0]['siteId']
      this.systemId = params[1]['systemId']
      this.getLinks = this.sysService.getLinks(this.siteId, this.systemId)

    })

    this.onAdd = new EventEmitter<ActionButtonEvent>();
    this.onEdit = new EventEmitter<ActionButtonEvent>();
    this.onDelete = new EventEmitter<ActionButtonEvent>();
    this.rowActionButtons.push({ icon: 'tv', tooltip: 'Show', eventEmitter: this.onEdit });

    this.topbarActionButton.push({ icon: 'add', tooltip: 'Add link', eventEmitter: this.onAdd });
    this.rowActionButtons.push({ icon: 'clear', tooltip: 'Remove', eventEmitter: this.onDelete });

    this.onAddSubscription = this.onAdd.subscribe(event => {
      this.addLinks();
    });


    this.onEditSubscription = this.onEdit.subscribe(event => {
      this.showLinksIniframe(event.eventData);
    });

    this.onDeleteSubscription = this.onDelete.subscribe(event => {
      console.log(event.eventData)
      this.deleteUser(event.eventData.uid);
    });
  }

  ngOnInit() {

   

  }


  
  addLinks() {

    const dialogRef = this.dialog.open(CommonPopup, {
      disableClose: true,
      width: '500px',
      data: {
        siteId: this.siteId,
        formData: {
          title: "Add links",
          inputFeilds: [
            {
              labelName: "Name",
              name: "name",
              required: false,
              type: "text",
              value: null,
              specialText: ""
            }, {
              labelName: "Link",
              name: "link",
              required: false,
              type: "text",
              value: null,
              specialText: ""
            }
          ],
          buttons: [
            {
              name: "ADD",
              type: "submit",
              color: "primary",
              validate: true
            }
          ]
        }
      }
    });

     dialogRef.afterClosed().subscribe(async result => {



      if (result) {

        console.log(result.value)
        this.sysService.addLinks(this.siteId,this.systemId,result.value)
      }
    });


  }




  ngOnDestroy(): void {
    this.getStockSub.unsubscribe()
  }


  deleteUser(id: number) {
    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "DELETE",
          message: " Are you sure to continue? ",
          buttons: ['Cancel', 'Yes']
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sysService.deleteLink(this.siteId, this.systemId,id)
      }
    });

  }

  showLinksIniframe(data){
    console.log(data)
    const dialogRef = this.dialog.open(Iframe , {
      disableClose: true,
      width: '350px',
      data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

}
